<template>
  <div class="companies">
    <MobileTable
      v-model:selection="store.state.assembly.selectedAssemblies"
      :label="$route.name"
      :columns="assembly.columns"
      :data="store.state.assembly.assemblies"
    />
    <DesktopTable
      v-model:selection="store.state.assembly.selectedAssemblies"
      :label="$route.name"
      :columns="assembly.columns"
      :data="store.state.assembly.assemblies"
    />
    <Actions :items="assembly.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/asambleas/nuevo");
    };
    const onDetail = async () => {
      if (store.state.assembly.selectedAssemblies.length !== 1) {
        store.state.toast.add({
          severity: "info",
          summary: "",
          detail: "Debe seleccionar un registro!",
          life: 5000,
        });
      } else {
        store.commit("setOpenMode", openMode.DETAIL);
        router.push("/asambleas/nuevo");
      }
    };
    const onRemove = async () => {
      if (store.state.assembly.selectedAssemblies.length !== 1) {
        store.state.toast.add({
          severity: "info",
          summary: "",
          detail: "Debe seleccionar un registro!",
          life: 5000,
        });
      } else {
        store.commit("setLoading", true);
        const response = await store.dispatch(
          actions.assemblyActions.delete,
          store.state.assembly.selectedAssemblies[0].id
        );
        if (response.ok) {
          store.commit("setSelectedAssemblies", []);
          await store.dispatch(actions.assemblyActions.findAll, {
            buildingId: store.state.general.selectedBuilding,
          });
          store.commit("setLoading", false);
        } else {
          store.commit("setLoading", false);
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
        }
      }
    };
    const onResolutions = async () => {
      if (store.state.assembly.selectedAssemblies.length !== 1) {
        store.state.toast.add({
          severity: "info",
          summary: "",
          detail: "Debe seleccionar un registro!",
          life: 5000,
        });
      } else {
        store.commit("setOpenMode", openMode.CREATE);
        router.push("/asambleas/resoluciones/asociar");
      }
    };

    const assembly = reactive({
      columns: [
        {
          field: "title",
          header: "Título",
          sort: true,
        },
        {
          field: "appointmentDate",
          header: "Fecha de Citación",
          sort: true,
          date: true,
        },
        {
          field: "link",
          header: "Link de Conferencia",
          sort: true,
        },
        {
          field: "status",
          header: "Estado",
          sort: true,
        },
        {
          field: "indResolution",
          header: "Resolución",
          sort: true,
        },
        {
          field: "createdAt",
          header: "Fecha de Creación",
          sort: true,
          date: true,
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/asambleas/nuevo"),
        },
        {
          name: "Detalle",
          action: onDetail,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/asambleas/nuevo"),
        },
        {
          name: "Eliminar",
          action: onRemove,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/asambleas/nuevo"),
        },
        {
          name: "Resoluciones",
          action: onResolutions,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/asambleas/nuevo"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedAssemblies", []);
      const finded = store.state.general.breadcrumbs.find(
        (item) => item.to === route.path
      );
      if (!finded)
        store.commit("addBreadcrumb", { label: route.name, to: route.path });
      await store.dispatch(actions.assemblyActions.findAll, {
        buildingId: store.state.general.selectedBuilding,
      });
      store.commit("setLoading", false);
    });

    return { store, assembly };
  },
};
</script>

<style scoped></style>
